import { CommandListVerticals } from "./commands/cmdListVerticals";
import { CommandListCatalogVersions } from "./commands/cmdListCatalogVersions";
import { CommandListCatalogMetrics } from "./commands/cmdListCatalogMetrics";
import { CommandListDimensions } from "./commands/cmdListDimensions";
import { CommandGetCatalogUsage, UsageOnly } from "./commands/cmdGetCatalogUsage";
import { CommandListEntityTypes } from "./commands/cmdListEntityTypes";
import { CommandListMetricTypes } from "./commands/cmdListMetricTypes";
import { CommandCreateVertical, CommandUpdateVertical, CommandDeleteVertical } from "./commands/cmdWriteVerticals";
import { CommandCreateEntityType, CommandUpdateEntityType, CommandDeleteEntityType } from "./commands/cmdWriteEntityTypes";
import { CommandCreateMetricType, CommandUpdateMetricType, CommandDeleteMetricType } from "./commands/cmdWriteMetricTypes";
import { CommandCreateMetric, CommandUpdateMetric, CommandDeleteMetric } from "./commands/cmdWriteMetrics";
import {
  CommandCreateDimension, CommandUpdateDimension, CommandDeleteDimension,
  CommandListDimensionValues, CommandCreateDimensionValue,
  CommandUpdateDimensionValue, CommandDeleteDimensionValue,
} from "./commands/cmdWriteDimensions";
import { CommandListCoreFieldSamples } from "./commands/cmdListCoreFieldSamples";
import { CommandCreateCoreFieldSample, CommandUpdateCoreFieldSample, CommandDeleteCoreFieldSample } from "./commands/cmdWriteCoreFieldSamples";
import { CoreFieldSampleIn, DimensionIn, DimensionValueIn, EntityTypeIn, MetricIn, MetricTypeIn, VerticalIn } from "@models/catalog.model";

// Facade over the tracked_data catalog API. Reads back the read-only browser (MPN-1189);
// writes power self-serve vertical authoring (MPN-1207).
export class CatalogService {
  // reads
  async listVerticals() { return new CommandListVerticals().run(); }
  async listMetrics(verticalCode: string) { return new CommandListCatalogMetrics().run(verticalCode); }
  async listDimensions(verticalCode: string) { return new CommandListDimensions().run(verticalCode); }
  async listEntityTypes(verticalCode?: string) { return new CommandListEntityTypes().run(verticalCode); }
  async listMetricTypes() { return new CommandListMetricTypes().run(); }
  async getUsage(verticalCode: string, only?: UsageOnly) { return new CommandGetCatalogUsage().run(verticalCode, only); }

  // verticals
  async createVertical(p: VerticalIn) { return new CommandCreateVertical().run(p); }
  async updateVertical(id: number, p: VerticalIn) { return new CommandUpdateVertical().run(id, p); }
  async deleteVertical(id: number) { return new CommandDeleteVertical().run(id); }

  // entity types
  async createEntityType(p: EntityTypeIn) { return new CommandCreateEntityType().run(p); }
  async updateEntityType(id: number, p: EntityTypeIn) { return new CommandUpdateEntityType().run(id, p); }
  async deleteEntityType(id: number) { return new CommandDeleteEntityType().run(id); }

  // metric types
  async createMetricType(p: MetricTypeIn) { return new CommandCreateMetricType().run(p); }
  async updateMetricType(id: number, p: MetricTypeIn) { return new CommandUpdateMetricType().run(id, p); }
  async deleteMetricType(id: number) { return new CommandDeleteMetricType().run(id); }

  // metrics
  async createMetric(p: MetricIn) { return new CommandCreateMetric().run(p); }
  async updateMetric(id: number, p: MetricIn) { return new CommandUpdateMetric().run(id, p); }
  async deleteMetric(id: number) { return new CommandDeleteMetric().run(id); }

  // dimensions
  async createDimension(p: DimensionIn) { return new CommandCreateDimension().run(p); }
  async updateDimension(id: number, p: DimensionIn) { return new CommandUpdateDimension().run(id, p); }
  async deleteDimension(id: number) { return new CommandDeleteDimension().run(id); }

  async listDimensionValues(dimensionId: number) { return new CommandListDimensionValues().run(dimensionId); }
  async createDimensionValue(dimensionId: number, p: DimensionValueIn) { return new CommandCreateDimensionValue().run(dimensionId, p); }
  async updateDimensionValue(dimensionId: number, id: number, p: DimensionValueIn) { return new CommandUpdateDimensionValue().run(dimensionId, id, p); }
  async deleteDimensionValue(dimensionId: number, id: number) { return new CommandDeleteDimensionValue().run(dimensionId, id); }

  // core field samples (MPN-1233)
  async listCoreFieldSamples(verticalCode: string) { return new CommandListCoreFieldSamples().run(verticalCode); }

  // history (MPN-1335) — by id, not code: the aggregate is owned by the Vertical row
  async listCatalogVersions(verticalId: number) { return new CommandListCatalogVersions().run(verticalId); }
  async createCoreFieldSample(p: CoreFieldSampleIn) { return new CommandCreateCoreFieldSample().run(p); }
  async updateCoreFieldSample(id: number, p: CoreFieldSampleIn) { return new CommandUpdateCoreFieldSample().run(id, p); }
  async deleteCoreFieldSample(id: number) { return new CommandDeleteCoreFieldSample().run(id); }
}
